import { SecondaryTab } from 'modules/common/components/SecondaryTab';

import { useGroupTabStyles } from './useGroupTabStyles';

export interface GroupTabProps {
  isLast: boolean;
  isSelected: boolean;
  label: string;
  onClick?: () => void;
}

export const GroupTab = ({
  isLast,
  isSelected,
  label,
  onClick,
}: GroupTabProps) => {
  const { classes } = useGroupTabStyles();

  return (
    <SecondaryTab
      className={classes.root}
      isLast={isLast}
      isSelected={isSelected}
      label={label}
      onClick={onClick}
    />
  );
};
